import { Module } from 'lib/vendor/terrific/Module';
import { Hook } from 'lib/vendor/terrific/Sandbox';

export default class ScrollingArrow extends Module {

	public on(callback : Hook) {
		const screenHeight = screen.height - 250;
		this.$ctx.on('click', () => {
			$('html, body').animate({scrollTop: window.pageYOffset + screenHeight}, 1000);
		});

		$(document).on('scroll', () => {
			this.$ctx.toggleClass('hidden', window.innerHeight + window.scrollY + 400 > document.body.clientHeight);
		});

		callback();
	}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/sdx/Tc.Module.ScrollingArrow.ts